import React, { useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "../Hooks";
import { getProductLists } from "../../requests/productListManagementRequests";
import { PageWrapper } from "../UI/Grid";
import Table from "../UI/Table";


const ProductListsPage = () => {
  const navigate = useNavigate();
  const { pid } = useParams();

  const result = useQuery({
    queryID: "productLists",
    request: getProductLists,
    queryVariables: { pid },
    forcedFilters: {},
    skip: !pid,
  });

  const onCardClick = (id) => {
    navigate(`/ProductList/${id}`);
  };

  const gridData = useMemo(() => {
    if (!result.data?.rows) return null;
    return result.data?.rows.map(({ id, name }) => ({
      key: id,
      id,
      title: name,
      //subtitle: "",
      iconName: "faPeopleGroup",
    }));
  }, [result]);

  return (
    <>
      <PageWrapper>
        <Table
          createLink={() => navigate("/ProductList/create")}
          createButtonText="Create Product List"
          createButtonIcon="faCartPlus" //or faDolly (the add product icon)
          title="Product List Management"
          backButtonLink="/Administration"
          gridData={gridData}
          hideProperties
          hidePager
          hideSearch
          isLoading={result.isLoading}
          hideToggle
          forceGrid
          onCardClick={(productList) => onCardClick(productList.id)}
        />
      </PageWrapper>
    </>
  );
};

export default ProductListsPage;
